<div class="container p-5 bg-white hem-confirm-modal text-dark text-left">
  <div class="modal-header d-flex justify-content-between align-items-center p-0">
    <h2 class="fw-bold m-0">
      {{ "Sigue estos pasos para comenzar" | translate }}
    </h2>

    <div class="clickable" (click)="onCloseConfirmationModalClick()">
      <img loading="lazy"
           data-src="{{ '/images/hecho-en-mexico/iconos/cerrar.svg' | blobstorage }}"
           alt="close"
           src="{{ '/images/hecho-en-mexico/iconos/cerrar.svg' | blobstorage }}">
    </div>
  </div>

  <p class="mt-2">
    {{ "Ahora diseña tu Sitio Web, sigue estos pasos:" | translate }}
  </p>

  <div class="row mb-3 d-flex justify-content-center align-items-center row-steps">
    <!-- Paso 1 -->
    <div class="col-md-3 d-flex justify-content-center mb-3">
      <div class="step-card h-100">
        <div class="step-number">1</div>
        <p class="step-info fs-6 text-start">
          {{ "Responde las preguntas del formulario de inicio." | translate }}
        </p>
        <div class="step-icon">
          <img loading="lazy" [src]="'/images/hecho-en-mexico/iconos/e-learning-laptop-math.svg' | blobstorage"
               data-src="{{ '/images/hecho-en-mexico/iconos/e-learning-laptop-math.svg' | blobstorage }}"
               alt="usuario" class="img-fluid mb-3 img-step-icon">
        </div>
      </div>
    </div>

    <!-- Paso 2 -->
    <div class="col-md-3 d-flex justify-content-center mb-3">
      <div class="step-card h-100">
        <div class="step-number">2</div>
        <p class="step-info fs-6 text-start">
          {{ "Espera la propuesta de la Inteligencia Artificial." | translate }}
        </p>
        <div class="step-icon">
          <img loading="lazy" [src]="'/images/hecho-en-mexico/iconos/design-tool-magic-wand.svg' | blobstorage"
               data-src="{{ '/images/hecho-en-mexico/iconos/design-tool-magic-wand.svg' | blobstorage }}"
               alt="monitor" class="img-fluid mb-3 img-step-icon">
        </div>
      </div>
    </div>

    <!-- Paso 3 -->
    <div class="col-md-3 d-flex justify-content-center mb-3">
      <div class="step-card h-100">
        <div class="step-number">3</div>
        <p class="step-info  fs-6 text-start">
          {{ "Perfecciona el diseño con las herramientas intuitivas." | translate }}
        </p>
        <div class="step-icon">
          <img loading="lazy" [src]="'/images/hecho-en-mexico/iconos/programming-monitor-type.svg' | blobstorage"
               data-src="{{ '/images/hecho-en-mexico/iconos/programming-monitor-type.svg' | blobstorage }}"
               alt="consola" class="img-fluid mb-3 img-step-icon">
        </div>
      </div>
    </div>

    <!-- Paso 4 -->
    <div class="col-md-3 d-flex justify-content-center mb-3">
      <div class="step-card h-100">
        <div class="step-number">4</div>
        <p class="step-info  fs-6 text-start">
          {{ "¡Listo!" | translate }}<br />
          {{ "Publica tu sitio." | translate }}
        </p>
        <div class="step-icon">
          <img loading="lazy" [src]="'/images/hecho-en-mexico/iconos/smiley-glasses.svg' | blobstorage"
               data-src="{{ '/images/hecho-en-mexico/iconos/smiley-glasses.svg' | blobstorage }}"
               alt="consola" class="img-fluid mb-3 img-step-icon">
        </div>
      </div>
    </div>

  </div>
  <!-- Buttons -->
  <div class="row p-3 align-items-center">
    <div *ngIf="dudaSetupUrl" class="col-12 col-md-6 offset-md-3 order-1 order-md-2">
      <button class="btn btn-primary w-100 text-uppercase" (click)="onGoToEditSiteClick()">
        {{'Ir al creador de sitios Akky' | translate }}
      </button>
    </div>
    <div *ngIf="!dudaSetupUrl" class="col-12">
      <p class="video-hem mx-auto text-center">
        <span class="fw-bold">{{'El proceso casi ha finalizado.' | translate }}</span> {{'No fue posible enlazar automáticamente tu sitio web con el dominio, pero puedes completar este paso desde el panel de control de tus servicios.' | translate }}
      </p>
    </div>
    <div *ngIf="!dudaSetupUrl" class="col-12 col-md-6 offset-md-3 order-1 order-md-2">
      <button class="btn btn-primary w-100 text-uppercase" (click)="onGoToPanel()">
        {{'Panel de control' | translate }}
      </button>
    </div>
  </div>
  <div class="row p-3 align-items-center">
    <div class="col-12">
      <p class="video-hem mx-auto fs-6 text-center">
        {{'Si necesitas ayuda, no dudes en contactar a nuestro' | translate }} <a [href]="whatsAppUrl" target="_blank"> {{'equipo de soporte.' | translate }}</a>
      </p>
    </div>
  </div>
</div>
